// extracted by mini-css-extract-plugin
export default {"accountPanelTotal":"AccountPanelTotal__accountPanelTotal--22Y","totalName":"AccountPanelTotal__totalName--3W-","totalAmount":"AccountPanelTotal__totalAmount--2tJ"};